declare const process;

const vdlPrefix = (className: string): string => {
  return 'vdl-' + className;
};

export default vdlPrefix;
